import * as MutationTypes from '@/store/mutation-types';

export default {
  openMenu({ commit }) {
    commit(MutationTypes.OPEN_MENU);
  },
  closeMenu({ commit }) {
    commit(MutationTypes.CLOSE_MENU);
  },
  openFileViewer({ commit }, file) {
    commit(MutationTypes.SET_CURRENT_OVERLAY_FILE, file);
    commit(MutationTypes.OPEN_FILE_VIEWER);
  },
  closeFileViewer({ commit }) {
    commit(MutationTypes.CLOSE_FILE_VIEWER);
  },
  resetBanner({ commit }) {
    commit(MutationTypes.RESET_BANNER);
  },
};
